import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '@indice/ng-components';
import { MobileViewModalComponent } from './mobile-view-modal/mobile-view-modal.component';
import { mergeMap, of } from 'rxjs';


@Component({
  selector: 'app-tab-pill-group-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab-pill-group-button.component.html',
  styleUrl: './tab-pill-group-button.component.css',
})
export class TabPillGroupButtonComponent implements OnInit {
  @Output() itemSelected = new EventEmitter<string>();
  @Input() items: TabPillGroupButton[] = [];
  @Input() inputPlaceholder: string = "Selection";
  @Input() alwaysShowPill: boolean = false;
  public activeElement: TabPillGroupButton | null = null;

  constructor(private _modalService: ModalService,) {

  }

  ngOnInit(): void {
    // # Set active button & Send item key to parent
    if (this.items.length > 0) {
      this.activeElement = this.items[0];
      this.itemSelected.emit(this.items[0].key);
    }

    // # Ensure the pill is visible on both desktop and mobile view
    // # only if there are exactly 2 items, as it won't fit otherwise
    if (this.alwaysShowPill) {
      this.items.length === 2 ? this.alwaysShowPill = true : this.alwaysShowPill = false
    }
  }

  onClick(item: TabPillGroupButton) {
    this.activeElement = item;

    // Send selected item key to parent
    this.itemSelected.emit(item.key);
  }

  mobileViewModalCase() {
    const mobileModal = this._modalService.show(MobileViewModalComponent, {
      keyboard: true,
      class: 'h-dvh md:h-auto',
      initialState: {
        modalItems: this.items,
        activeModalElement: this.activeElement,
      },
    });

    mobileModal.onHidden?.pipe(
      mergeMap((x: any) => {
        if (x.result.activeModalElement) {
          this.activeElement = x.result.activeModalElement;
          // Send selected item key to parent
          this.itemSelected.emit(this.activeElement?.key);
        }
        return of();
      }),
    )
    .subscribe();
  }
}


export interface TabPillGroupButton {
  key: string;
  title?: string;
  icon?: string;
}
